export default __webpack_public_path__ + "static/media/titulo.ae9fe207.png";